import { Flex, Image } from "antd";
import { useTranslation } from "react-i18next";
import { envChangeType } from "../../plugins/utils";
import styles from "./style.module.scss";

const Partners = ({ hideTitle = false }) => {
  const { t } = useTranslation();

  const partnersEnum = [
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner1.png`,
      name: "partner1",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner2.png`,
      name: "partner2",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner3.png`,
      name: "partner3",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner4.png`,
      name: "partner4",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner5.png`,
      name: "partner5",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner6.png`,
      name: "partner6",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner7.png`,
      name: "partner7",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner8.png`,
      name: "partner8",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner9.png`,
      name: "partner9",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner10.png`,
      name: "partner10",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner11.png`,
      name: "partner11",
    },
    {
      src: `/images/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/home/partners/partner12.png`,
      name: "partner12",
    },
  ];

  return (
    <div className={`${styles.partners} ${hideTitle ? styles.noGap : ""}`}>
      {!hideTitle && <div className={styles.title}>{t("home.partners")}</div>}
      <Flex wrap gap={30} justify="center">
        {partnersEnum.map((item, index) => {
          return (
            <Image
              key={index}
              src={item.src}
              alt={item.name}
              preview={false}
              className={styles.img}
            />
          );
        })}
      </Flex>
    </div>
  );
};

export default Partners;
